export const displayName = "MatterIntake" as const;

export const aboutUs =
  `${displayName} is the easiest way to collect information from your clients and contacts - remotely or in person.` as const;
